<div class="document-container">
  <h2>Documentos emitidos</h2>

  <!-- Filtros -->
  <div class="document-filters">
    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>Situação</mat-label>
      <mat-select [(ngModel)]="filter.situacao">
        <mat-option *ngFor="let situacao of situacoes" [value]="situacao">
          {{ situacao }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-radio-group [(ngModel)]="filter.tipo" class="filter-item tipo-radio">
      <mat-radio-button value="cpf">Pessoa Física (CPF)</mat-radio-button>
      <mat-radio-button value="cnpj">Pessoa Jurídica (CNPJ)</mat-radio-button>
    </mat-radio-group>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>CPF</mat-label>
      <input matInput [(ngModel)]="filter.cpf" placeholder="999.999.999-99" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>Protocolo</mat-label>
      <input matInput [(ngModel)]="filter.protocolo" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>Tipo de documento</mat-label>
      <mat-select [(ngModel)]="filter.tipoDocumento">
        <mat-option *ngFor="let tipo of tiposDocumento" [value]="tipo">
          {{ tipo }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>Usuário envio (CPF/CNPJ)</mat-label>
      <input matInput [(ngModel)]="filter.usuarioEnvio" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>Tipo de arquivo</mat-label>
      <mat-select [(ngModel)]="filter.tipoArquivo">
        <mat-option *ngFor="let tipo of tiposArquivo" [value]="tipo">
          {{ tipo }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>Ano</mat-label>
      <input matInput [(ngModel)]="filter.ano" type="number" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>Número</mat-label>
      <input matInput [(ngModel)]="filter.numeroDocumento" />
    </mat-form-field>

    <!-- Botão Consultar -->
    <div class="filter-actions">
      <button mat-raised-button color="primary" (click)="consultarDocumentos()">
        Consultar
      </button>

      <button mat-raised-button color="primary" (click)="openCreateDocumentDialog()">Criar Novo Documento</button>

    </div>
  </div>

  <!-- Tabela de Documentos -->
  <div class="document-table">
    <h3>Documentos emitidos</h3>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>
      <ng-container matColumnDef="numero">
        <th mat-header-cell *matHeaderCellDef>Número</th>
        <td mat-cell *matCellDef="let element">{{ element.numero }}</td>
      </ng-container>
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
      </ng-container>
      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let element">{{ element.nome }}</td>
      </ng-container>
      <ng-container matColumnDef="situacao">
        <th mat-header-cell *matHeaderCellDef>Situação</th>
        <td mat-cell *matCellDef="let element">{{ element.situacao }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>